// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3Yqj7h2RNH7dQA8Ba1L6BG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HighlightTitleForPublisherPackage/HighlightTitleForPublisherPackage.scss
// module id = 1620
// module chunks = 0